export default {
  title: '{{company}} hat deine Abholzeit geändert',
  title_on_site: '{{company}} hat geändert, wann deine Bestellung serviert wird',
  new_time_label: 'Neue Zeit',
};
